import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import type { UpdateBillingManager } from '@ctct/application-layer';
import type { UpdateBillingHooks, UpdateBillingPageStore } from '@ctct/state-client-layer';
import { useUpdateBillingInfo } from '@ctct/state-server-layer';

interface Props {
  pageStore: UpdateBillingPageStore;
  initializer: Pick<UpdateBillingManager, 'updateBillingInit'>;
  hooks: UpdateBillingHooks;
}

export const useUpdateBillingWidget = ({ initializer, pageStore, hooks }: Props) => {
  const updateBillingInfo = useUpdateBillingInfo();
  const { t } = useTranslation();

  const componentProps = useMemo(
    () => ({
      ...initializer.updateBillingInit({ pageStore, mutations: [updateBillingInfo], t }),
      hooks,
    }),
    [hooks, initializer, pageStore, t, updateBillingInfo]
  );

  return componentProps;
};

export type UpdateBillingWidgetProps = ReturnType<typeof useUpdateBillingWidget>;
